import React from "react";
import { PayrollOutputReport } from "../../../../assets/icons";
import MyTeamPayrollOutputReportLayout from "./MyTeamPayrollOutputLayout";
import { MyTeamPayrollOutputSummaryDTO } from "../../../../models/my-team-payroll-output-summary/my-team-payroll-output-summary-dto";
import { useTranslation } from "react-i18next";

const MyTeamPayrollOutputReportLink = ({
  customSummary,
  loading,
}: {
  customSummary: MyTeamPayrollOutputSummaryDTO;
  loading: boolean;
}) => {
  const { t } = useTranslation();
  const tRP = "components.custom_widget_links.my_team_payroll_output";
  const lastAvailableDate = customSummary?.lastAvailable;

  let date: string = "-";

  if (!!lastAvailableDate && new Date(lastAvailableDate)?.getFullYear() > 1900) {
    const year = new Date(lastAvailableDate).getFullYear();
    const month =
      new Date(lastAvailableDate).getMonth() + 1 < 10
        ? `0${new Date(lastAvailableDate).getMonth() + 1}`
        : new Date(lastAvailableDate).getMonth() + 1;
    date = `${year} ${month}`;
  }

  return (
    <>
      <MyTeamPayrollOutputReportLayout
        date={date}
        loading={loading}
        linkName={`${t(`${tRP}.see_payroll_output`)}`}
        textForDate={`${t(`${tRP}.last_available`)}:`}
        Icon={PayrollOutputReport}
      />
    </>
  );
};
export default MyTeamPayrollOutputReportLink;
